/*
 * This program is part of an OpenCms Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import jQuery                   from 'jquery';

// import bootstrap                from 'bootstrap';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tab';
import 'bootstrap/js/collapse';
import 'bootstrap/js/transition';

import jsDevice                 from 'current-device';
import fitVids                  from 'fitvids';
import lazySizes                from 'lazysizes';
Object.assign(lazySizes.cfg,    { init:false }); // otherwise device based configuration will not work

import * as RebrushList         from './script-lists.js';
import * as RebrushNavigation   from './script-navigation.js';
import * as RebrushDisqus       from './script-disqus.js';
import * as RebrushMap          from './script-map.js';
import * as RebrushAnalytics    from './script-analytics.js';
import * as PrivacyPolicy       from './script-privacy-policy.js';

import jQueryExtensions         from './script-jquery-extensions.js';
import unobfuscateString        from './script-unobfuscate.js';
import scrolltotop              from './script-back-to-top.js';

import { _OpenCmsReinitEditButtons, _OpenCmsInit } from './script-opencms-callbacks.js';

var DEBUG = (getParameter("jsdebug") != null);
var VERBOSE = DEBUG && (getParameter("jsverbose") != null);

// Module implemented using the "revealing module pattern", see
// https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
// https://www.christianheilmann.com/2007/08/22/again-with-the-module-pattern-reveal-something-to-the-world/
var Rebrush = function(jQ) {

    "use strict";

    // class to mark element as hidden
    var HIDE_ELEMENT_CLASS="element-hide";

    // container for information passed from CSS to JavaScript
    var m_info = {};

    // the color theme passed from CSS to JavaScript
    var m_theme = null;

    // the grid size when the page was loaded
    var m_gridInfo = {};

    // the current window
    var m_$window = jQ(window);

    // height of current window
    var m_windowHeight = m_$window.height();

    // width of current window
    var m_windowWidth = m_$window.width();

    // attach event listener to window resize event (debounced)
    m_$window.resize(debounce(function() {
        m_windowHeight = m_$window.height();
        m_windowWidth = m_$window.width();

        if (DEBUG) console.info("Rebrush current grid size: " + m_gridInfo.currentSize());

        setMedienTubeWidth();
        if (RebrushNavigation.updateWidth) {
            try {
                RebrushNavigation.updateWidth();
            } catch (err) {
                console.warn("RebrushNavigation.updateWidth() error " + err);
            }
        }
    }, 100));


    function windowHeight() {
        return m_windowHeight;
    }


    function windowWidth() {
        return m_windowWidth;
    }


    function toolbarHeight() {
        return isEditMode() ? 52 : 0;
    }


    function windowScrollTop() {
        return m_$window.scrollTop();
    }


    function device() {
        // returns information about the current device
        // this is provided by the current-device plugin
        return jsDevice;
    }


    function debounce(func, wait, immediate) {
        // debounce function to optimize JavaScript events
        // see https://davidwalsh.name/javascript-debounce-function
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = window.setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }


    function addInfo(info) {

        jQ.extend(m_info, info);

        if (DEBUG) console.info("Rebrush info extended to:");
        if (DEBUG) jQ.each(m_info, function( key, value ) { console.info( "- " + key + ": " + value ); });
    }


    function hasInfo(key) {

        return key in m_info;
    }


    function getInfo(key) {

        if ((key in m_info) && (m_info[key] != "none")) {
            return m_info[key];
        }
        return null;
    }


    function isNotEmpty(string) {
        // checks if the argument variable is of type string and has a length > 0
        var result = false;
        if ((typeof string === "string") && (string.trim().length > 0)) {
           result = true;
        }
        return result;
    }


    function removeQuotes(string) {
        // passing variables from SCSS to JavaScript
        // see https://css-tricks.com/making-sass-talk-to-javascript-with-json/
        if (typeof string === 'string' || string instanceof String) {
            string = string.replace(/^['"]+|\\|(;\s?})+|['"]$/g, '');
        }
        return string;
    }


    function parseJson(data) {
        // parses JSON with error handling
        var result = {};
        if (isNotEmpty(data) && (data != "none")) {
            try {
                result = JSON.parse(data);
            } catch (err) {
                console.warn("Error parsing JSON data '" + data + "'", err);
            }
        }
        return result;
    }

    function getCssJsonData(elementId) {
        // reads JSON data from the CSS and returns it as an JS object
        var data = getCssDataFromId(elementId);
        if (DEBUG) console.info("Rebrush data found in ::before: [" + data + "]");
        return parseJson(data);
    }


    function getCssDataFromElement(element, after) {
        // read data from ::before or ::after elements in the CSS
        var selector = after ? '::after' : '::before';
        var data = null;
        if (element) {
            if (window.getComputedStyle && window.getComputedStyle(element, selector) ) {
                data = window.getComputedStyle(element, selector);
                data = data.content;
            }
        }
        return data != null ? removeQuotes(data) : data;
    }


    function getCssDataFromId(elementId, after) {
        var element = document.getElementById(elementId);
        return getCssDataFromElement(element, after);
    }


    function getCssDataFromJQuery($element, after) {
        var element = $element.get(0);
        return getCssDataFromElement(element, after);
    }


    function initInfo() {
        // the Rebrush template stores JSON encoded information for the JavaScript
        // in the HTML elements with the ID #rebrush-info
        // initialize info sections with values from data attributes
        jQ('#rebrush-info').each(function(){
            var $element = jQ(this);
            if (typeof $element.data("info") != 'undefined') {
                var $info = $element.data("info");
                addInfo($info);
            }
            m_theme = getCssJsonData($element.attr('id'));
            if (DEBUG) console.info("Rebrush theme JSON: " + getThemeJSON("main-theme", []));
        });

        initGridInfo();
    }


    function getThemeJSON(key, defaultValue) {
        // the Rebrush template themes store several values in the CSS by JSON
        // these values are returned by this function
        // this way it is possible to pass information from the CSS to the JavaScript
        // currently the Rebrush theme to passes the following information to the Rebrush JS:
        // * color information (main theme colors, background colors, map marker colors...)
        // * information about the grid size (responsive breakpoints, points where the mobile nav appears)
        // * header information (stick header enabled or disabled) - note that the JS can overwrite this
        // * ...other stuff
        var result = defaultValue; // default return color when all else fails
        if (m_theme) {
            try {
                var col = Object.byString(m_theme, key);
                if (typeof col != "undefined") {
                    result = col;
                }
            } catch (e) {
                // result will be default
            }
        }

        return result;
    }


    function isOnlineProject() {
        // returns if the current OpenCms project is the online project
        // this information about is directly rendered into the template by OpenCms when the page is created
        // it is stored in the #rebrush-info HTML element
        return ("online" == m_info["project"]);
    }


    function isEditMode() {
        // returns "true" if OpenCms runs in edit mode
        // this means the "offline" project is selected AND the edit buttons are enabled in ADE
        // this information about is directly rendered into the template by OpenCms when the page is created
        // it is stored in the #rebrush-info HTML element
        return ("true" == m_info["editMode"]);
    }


    function gridInfo() {
        // function wrapper for the gridInfo variable
        return m_gridInfo;
    }


    function initGridInfo() {
        // update grid size from CSS
        m_gridInfo.grid = getCssDataFromId('rebrush-grid-info');
        if (DEBUG) console.info("Rebrush grid size: " + m_gridInfo.grid);

        var gridInfo = getCssDataFromId('rebrush-grid-info', true);
        gridInfo = gridInfo.replace(new RegExp('px', 'g'), '');
        if (DEBUG) console.info("Rebrush grid info: [" + gridInfo + "]");
        if (isNotEmpty(gridInfo)) {
            jQ.extend(m_gridInfo, JSON.parse(gridInfo));
        }
        if (DEBUG) console.info("Rebrush screen xs max:" + m_gridInfo.xsMax + " lg min:" + m_gridInfo.lgMin  + " desktop head nav min:" + m_gridInfo.navDeskMin);
        if (DEBUG) console.info("Rebrush fixed header nav setting: " + m_gridInfo.navFixHeader);

        m_gridInfo.currentSize = function() {
            if (m_windowWidth <= this.xsMax) {
                return "xs";
            }
            if (m_windowWidth <= this.smMax) {
                return "sm";
            }
            if (m_windowWidth <= this.mdMax) {
                return "md";
            }
            if (m_windowWidth >= this.lgMin) {
                return "lg";
            }
            return "unknown";
        }

        m_gridInfo.navType = function() {
            if (m_windowWidth <= this.navMobMax) {
                return "mobile";
            }
            if (m_windowWidth >= this.navDeskMin) {
                return "desktop";
            }
            return "unknown";
        }

        m_gridInfo.isMaxXs = function() { return m_windowWidth <= this.xsMax };
        m_gridInfo.isMaxSm = function() { return m_windowWidth <= this.smMax };
        m_gridInfo.isMaxMd = function() { return m_windowWidth <= this.mdMax };

        m_gridInfo.isMinSm = function() { return m_windowWidth >= this.smMin };
        m_gridInfo.isMinMd = function() { return m_windowWidth >= this.mdMin };
        m_gridInfo.isMinLg = function() { return m_windowWidth >= this.lgMin };

        m_gridInfo.isDesktopNav = function() { return m_windowWidth >= this.navDeskMin };
        m_gridInfo.isMobileNav = function() { return m_windowWidth < this.navDeskMin };
        m_gridInfo.navPos = function() { return this.navMobPos };
        m_gridInfo.getNavFixHeader = function() { return (this.navFixHeader) };
    }


    function calcRatio(ratio) {
        // calculates the ratio of an image based on its pixel size
        // used by some plugins (e.g. RevSlider)
        // the argument "ratio" has to have the format of the "image.size" property in OpenCms
        var result = {};
        result.valid = false;
        if (ratio != '') {
            ratio = ratio.toString();
            var i = ratio.indexOf('-');
            if (i > 0) {
                ratio = ratio.replace(',', '.');
                var wd = parseFloat(ratio.substring(0, i));
                var hd = parseFloat(ratio.substring(i + 1));
                result.wd = wd;
                result.hd = hd;
                result.ratio = wd / hd;
                result.valid = true;
            }
        }
        return result;
    }


    function post(path, params, method) {
        method = method || "post"; // Set method to post by default if not specified.

        var form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);

        for(var key in params) {
            if(params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
             }
        }

        document.body.appendChild(form);
        form.submit();
    }


    function scrollToAnchor($anchor, offset) {
        RebrushNavigation.scrollToAnchor($anchor, offset);
    }


    function initJavaScriptMarker() {
        // adds a CSS class "hasscript" to the document body so CSS can react if JS is available or not
        // when initially loaded, the page has the class "noscript" attached
        jQ(document.documentElement).removeClass("noscript");
        jQ(document.documentElement).addClass("hasscript");
    }


    function initFitVids() {
        // set video widths using the fidVids plugin
        fitVids({
            players: [ 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="slideshare.net"]', 'iframe[src*="medien-tube.de"]', 'iframe[src*="domradio.de"]' ],
            ignore: ['.type-media iframe[src*="youtube-nocookie.com"]'] // used by media element
        });
        setMedienTubeWidth();
    }


    function setMedienTubeWidth() {
        var $medienTubeVideos = jQ("iframe[src*='medien-tube.de']");
        if (VERBOSE) console.info("iframe[src*='medien-tube.de'] elements found: " + $medienTubeVideos.length);
        $medienTubeVideos.each(function() {
            var $this = $(this);
            var width = $this.parent().width();
            if (width == 0) {
                width = "100%";
            }
            $this.width(width);
            if (DEBUG) console.info("Set MedienTube video parent container width to: " + width);
        });
    }

    // Affix elements, restricted to a parent container
    var m_affixElements = [];

    // Update Affix elements
    function updateAffix() {
        if (VERBOSE) console.info("Affix: update, m_affixElements=" + m_affixElements.length);
        for (var i=0; i<m_affixElements.length; i++) {
            var toolbarHeight = Rebrush.toolbarHeight();
            var affix = m_affixElements[i];
            var $element = affix.$element;
            var $parent =  affix.$parent;
            var topOffset = affix.top;
            var topOffsetFixed = affix.topFixed;
            var pHeight = $parent.outerHeight(true);
            var eHeight = $element.outerHeight(true);
            var docHeight = jQ(document).height();
            var scrollTop = m_$window.scrollTop();
            var top = $parent.offset().top - toolbarHeight + topOffset - topOffsetFixed;
            var bottom = top + (pHeight - eHeight) - topOffset;

            if (VERBOSE) console.info("Affix: docHeight=" + docHeight + " pHeight=" +  pHeight + " eHeight=" +  eHeight + " top=" + top + " bottom=" + bottom + " scrollTop=" + scrollTop);

            var isFixedTop = scrollTop > top;
            var isFixedBottom = isFixedTop && (scrollTop >= bottom);

            if (VERBOSE) console.info("Affix isFixed=" + (isFixedTop || isFixedBottom) + " isFixedTop=" + isFixedTop + " isFixedBottom=" + isFixedBottom);
            if (isFixedBottom) {
                $element.removeClass("affix affix-top").addClass("affix-bottom");
                $element.css("top", pHeight - eHeight);
            } else if (isFixedTop) {
                $element.removeClass("affix-top affix-bottom").addClass("affix");
                $element.css("top", toolbarHeight + topOffsetFixed);
            } else {
                $element.removeClass("affix-bottom affix").addClass("affix-top");
                $element.css("top", topOffset);
            }
        }
    }

    // Init Affix elements
    function initAffixes() {
        var $affixes = jQ('.ap-affix-parent .ap-affix');
        if (DEBUG) console.info(".ap-affix-parent .ap-affix elements found: " + $affixes.length);
        $affixes.each(function() {
            var $element = jQ(this);
            var $parent = $element.parents(".ap-affix-parent").first();
            var affix = {};
            affix.$element = $element;
            affix.$parent = $parent;
            var topCss = $element.css("top");
            if (typeof topCss !== "undefined" ) { topCss = topCss.match(/-?\d+/) } else { topCss = "0" };
            var options = getCssDataFromJQuery($element);
            var data = parseJson(options);
            if (typeof data.topFixed === "undefined" ) { data.topFixed = 0 };
            if (VERBOSE) console.info("Affix: css JSON data is=" + options + " topFixed=" + data.topFixed);
            affix.top = parseInt(topCss, 10);
            affix.topFixed = data.topFixed;
            m_affixElements.push(affix);
            if (VERBOSE) console.info("Affix: added top=" + affix.top + " topFixed=" + affix.topFixed);
        });
        if (m_affixElements.length > 0) {
            m_$window.on('scroll resize', function() { updateAffix() }); // can not use dabouce, will be to "jaggy"
            updateAffix(true);
        }
    }


    function initElements(parent) {
        // call back for Ajax methods to initialize dynamic Rebrush elements
        initFitVids();
        // in case a dynamic list contains audio elements, make sure the required audio script is available
        loadAudioScript(function() { initMedia(parent) });
        initTooltips(parent);

        // reset the OpenCms edit buttons
        debounce(_OpenCmsReinitEditButtons, 500);
    }


    function loadAudioScript(callback) {
        // load audio script if required
        var audioScriptRequired = requiresModule(".type-media.audio, [data-audio]");
        if (audioScriptRequired && ((typeof window.AudioData === "undefined") || (typeof window.AudioData.initAudioElement !== "function"))) {
            window.AudioData = false;
            if (DEBUG) console.info("loadAudioScript() - Loading audio script...");
            try {
                import(
                    /* webpackChunkName: "rb-audio" */
                    "./script-audio.js").then( function ( AudioData ) {
                    if (DEBUG) console.info("loadAudioScript() - Audio script was loaded!");
                    AudioData.init(jQ, DEBUG);
                    window.AudioData = AudioData;
                    if (typeof callback === "function") {
                        callback();
                    }
                });
            } catch (err) {
                console.warn("loadAudioScript() error", err);
            }
        } else {
            if (DEBUG) console.info("loadAudioScript() - Audio script " + (audioScriptRequired ? "alreay loaded." : "not required."));
            if (typeof callback === "function") {
                callback();
            }
        }
    }


    function initLazyImageLoading() {
        // initialize lazy loading of images using the lazySizes plugin
        var lazySizesCfg = { init:true };
        if (device().desktop()) {
            lazySizesCfg.expFactor = 2.0; // load elements "not so near" for desktop
            lazySizesCfg.loadMode = 3; // load elements "not so near" for desktop
        } else {
            lazySizesCfg.loadMode = 1; // only load visible elements for mobile
        }
        // see https://github.com/aFarkas/lazysizes/issues/410
        Object.assign(lazySizes.cfg, lazySizesCfg);
        lazySizes.init();
    }


    function initTooltips(parent) {
        // initialize bootstrap tooltips
        parent = parent || '';
        var selector = parent + ' [data-toggle="tooltip"]';
        var $tooltips = jQ(selector);
        if (DEBUG) console.info(selector + " tooltips found: " +  $tooltips.length);
            if ($tooltips.length > 0) {
            $tooltips.tooltip({
                container: 'body',
                placement: 'top',
                delay: { 'show': 100, 'hide': 100 }
            });
            if (!device().desktop()) {
                // automatically close the tooltip
                $tooltips.on('shown.bs.tooltip', function (event) {
                    setTimeout(function () {
                        $(event.target).tooltip('hide');
                    }, 2500);
                });
            }
        }
    }


    function initMedia(parent) {
        // initialize Media element click handlers
        parent = parent || '';
        var selector = parent + ' .ap-media .preview, ' + parent + ' .type-media .preview';
        var $mediaElements = jQ(selector);
        if (DEBUG) console.info(selector + " elements found: " + $mediaElements.length);
        $mediaElements.each(function() {

            var $element = jQ(this);
            var data = $element.data("preview");
            if (data && data.template) {
                if ($element.width() < 300) {
                    $element.addClass("narrow");
                }
                $element.off("click");
                $element.on("click", data, function(event) {
                    var template = data.template;
                    var $p = $element.parent();
                    $p.removeClass("ap-raise-animation ap-shadow-animation ap-inset-animation ap-kenburns-animation animated-box");
                    $p.parent().addClass("play revealed");

                    if (template == "audio") {
                        $element.off("click");
                        if (window.AudioData) {
                            window.AudioData.initAudioElement($element, true);
                        }
                    } else {
                        $element.remove();
                        $p.append(decodeURIComponent(template));
                        initFitVids();
                    }
                });
            }
        });
    }


    function checkVersion() {
        // writes version information about the Rebrush template to the console
        var sassVersion = getCssDataFromId('rebrush-sass-version');
        var pluginsCssVersion = getCssDataFromId('rebrush-plugins-version');

        console.info("This is the Rebrush Template for OpenCms" +
                     "SASS " + sassVersion +
                     " - Plugins " + pluginsCssVersion +
                     " - JavaScript " + WEBPACK_SCRIPT_VERSION);
    }


    function addInit(initFunction) {
        // Add a function to the Rebrush init process
        // this can either be used for an external Script, or by an Rebrush module
        if (DEBUG) console.info("Rebrush added init function: " + initFunction.name);
        window.RebrushInit.push(initFunction);
    }


    function initScripts() {
        // register additional JavaScripts to Rebrush
        // the idea here is that additional javaScrips are started from Rebrush rather then registering their own "window.onload" event
        // this way it can be ensures that the vital page functions provied by Rebrush are already in place when the additional JS is executed
        var $initScripts = jQ('.rebrush-initscript');
        if (DEBUG) console.info(".rebrush-initscript elements found: " + $initScripts.length);
        $initScripts.each(function() {

            var $element = jQ(this);
            if (typeof $element.data("script") != 'undefined') {
                var script = $element.data("script");
                if (DEBUG) console.info("initscript found:" + script);
                addInit(window[script]);
            }
        });
    }


    function initFunctions() {
        // calls all init() functions hat have registered itself to Rebrush
        for (var i=0; i<window.RebrushInit.length; i++) {
            try {
                var initFunction = window.RebrushInit[i];
                if (DEBUG) console.info("Rebrush executing function from RebrushInit[]: " + initFunction.name);
                initFunction(jQ, DEBUG);
            } catch (err) {
                console.warn("Rebrush.initFunctions() error", err);
            }
        }

        var _functions = window.rebrush.getInitFunctions();
        for (var i=0; i < _functions.length; i++) {
            try {
                var initFunction = _functions[i];
                if (DEBUG) console.info("Rebrush executing function from getInitFunctions(): " + initFunction.name);
                initFunction(jQ, DEBUG);
            } catch (err) {
                console.warn("Rebrush.initFunctions() error", err);
            }
        }
    }

    function requiresModule(selector) {
        // checks if a specific module is required by checking for special selectors
        return (jQ(selector).length > 0);
    }


    var m_cssTimer = 0;
    function waitForCss() {
        var element = document.getElementById("rebrush-info");
        if (window.getComputedStyle(element).visibility == "hidden") {
            initAfterCss();
        } else {
            m_cssTimer += 50;
            setTimeout(function() { waitForCss() }, 50);
        }
    }


    function removePnbspP() {
        // removes <p>&nbsp;</p> paragraphs
        // see https://stackoverflow.com/questions/10225967/remove-p-nbsp-p-with-jquery-if-no-value
        if (!isEditMode()) {
            var pcount = 0;
            jQ('.remove-p-nbsp-p p').each(function() {
                var $this = $(this);
                if($this.html().replace(/\s|&nbsp;|<br>/g, '').length == 0) {
                    $this.remove();
                    pcount++;
                }
            });
            if (DEBUG) console.info("Removed " + pcount + " <p>&nbsp;</p> paragraphs.");
        }
    }


    function setSearchText(defaultValue, input, onfocus) {
        onfocus = onfocus || false;
        if (onfocus) {
            // removes the default text from search input field if the field is clicked
            if(input.value == defaultValue) {
                input.value = '';
            }
        } else {
            // adds default text to search input field if the field looses the focus and it is empty
            if(input.value == '') {
                input.value = defaultValue;
            }
        }
    }


    function hideElement($element) {
        if (typeof $element.data("hidemessage") != "undefined") {
            $element.addClass(HIDE_ELEMENT_CLASS);
            $element.addClass("error");
        }
    }


    function isElementHidden($element, callback) {

        if (typeof $element.data("hidemessage") != "undefined") {
            // add the hide element class
            $element.addClass(HIDE_ELEMENT_CLASS);
            // show the element by clicking on the element
            jQ($element).on("click",function(event) {
                // remove handler and remove class
                jQ(event.currentTarget).off("click")
                jQ(event.currentTarget).removeClass(HIDE_ELEMENT_CLASS);
                callback(event);
            });
            return true;
        }
        return false;
    }


    function initAfterCss() {

        if (DEBUG) console.info("Rebrush.initAfterCss() - CSS wait time: " + m_cssTimer + "ms");
        checkVersion(); // output a JS console information about the Rebrush version
        if (DEBUG) console.info("Rebrush device info: " + device().type);

        // initialize
        try {
            initInfo();
        } catch (err) {
            console.warn("Rebrush.initInfo() error", err);
        }

        try {
            initAffixes();
        } catch (err) {
            console.warn("Rebrush.initAffixes() error", err);
        }

        try {
            removePnbspP();
        } catch (err) {
            console.warn("Rebrush.removePnbspP() error ", err);
        }

        try {
            PrivacyPolicy.init(jQ, DEBUG);
            window.PrivacyPolicy = PrivacyPolicy;
        } catch (err) {
            console.warn("PrivacyPolicy.init() error", err);
        }

        try {
            initElements();
        } catch (err) {
            console.warn("Rebrush.initElements() error", err);
        }

        try {
            RebrushNavigation.init(jQ, DEBUG, Rebrush);
            window.RebrushNavigation = RebrushNavigation;
        } catch (err) {
            console.warn("RebrushNavigation.init() error", err);
        }

        try {
            RebrushList.init(jQ, DEBUG);
            window.RebrushList = RebrushList;
        } catch (err) {
            console.warn("RebrushList.init() error", err);
        }

        try {
            RebrushMap.init(jQ, DEBUG);
            window.RebrushMap = RebrushMap;
        } catch (err) {
            console.warn("RebrushMap.init() error", err);
        }

        try {
            RebrushDisqus.init(jQ, DEBUG);
        } catch (err) {
            console.warn("RebrushDisqus.init() error", err);
        }

        try {
            RebrushAnalytics.init(jQ, DEBUG);
        } catch (err) {
            console.warn("RebrushAnalytics.init() error", err);
        }

        // now initialize optional modules

        if (requiresModule(".ap-map-osm")) {
            try {
                 import(
                    /* webpackChunkName: "rb-map-osm" */
                    "./script-osm.js").then( function ( OsmMap ) {
                       OsmMap.init(jQ, DEBUG);
                       window.OsmMap = OsmMap;
                 });
            } catch (err) {
                 console.warn("OsmMap.init() error", err);
            }
         }

        if (requiresModule(".ap-slick-slider")) {
            try {
                import(
                    /* webpackChunkName: "rb-slider-slick" */
                    "./script-slider-slick.js").then( function ( RebrushSliderSlick ) {
                    RebrushSliderSlick.init(jQ, DEBUG);
                });
            } catch (err) {
                console.warn("RebrushSliderSlick.init() error", err);
            }
        }

        if (requiresModule(".ap-imageseries, [data-imagezoom]")) {
            try {
                import(
                    /* webpackChunkName: "rb-imageseries" */
                    "./script-imageseries.js").then( function (RebrushImageSeries) {
                    RebrushImageSeries.init(jQ, DEBUG);
                });
            } catch (err) {
                console.warn("RebrushImageSeries.init() error", err);
            }
        }

        if (requiresModule(jQ, ".ap-shariff")) {
            try {
                import(
                    /* webpackChunkName: "rb-shariff" */
                    "shariff/dist/shariff.min.js").then( function(Shariff) {
                    if (DEBUG) console.info("Shariff module loaded!");
                });
            } catch (err) {
                console.warn("RebrushShariff.init() error", err);
            }
        }

        loadAudioScript();

        try {
            // this must come directly before initFunctions()
            initScripts();
        } catch (err) {
            console.warn("Rebrush.initScripts() error", err);
        }
        try {
            // this must come last
            initFunctions();
        } catch (err) {
            console.warn("Rebrush.initFunctions() error", err);
        }

        // add event listeners for Bootstrap elements
        _OpenCmsInit(jQ, DEBUG)
    }


    function init() {
        // main init function - called from jQuery(document).ready() - see below in this script
        if (DEBUG) console.info("Rebrush.init() - Modularized version");
        window.Rebrush = Rebrush;

        try {
            initJavaScriptMarker(); // set JavaScript marker class to <html>
        } catch (err) {
            console.warn("Rebrush.initJavaScriptMarker() error", err);
        }
        try {
            initLazyImageLoading();
        } catch (err) {
            console.warn("Rebrush.initLazyImageLoading() error", err);
        }

        waitForCss();
    }


    // public available functions
    return {
        init: init,
        calcRatio: calcRatio,
        debounce: debounce,
        device: device,
        getCssJsonData: getCssJsonData,
        getInfo: getInfo,
        getThemeJSON: getThemeJSON,
        gridInfo: gridInfo,
        hasInfo: hasInfo,
        hideElement: hideElement,
        initElements: initElements,
        isEditMode: isEditMode,
        isElementHidden: isElementHidden,
        isOnlineProject: isOnlineProject,
        post: post,
        scrollToAnchor: scrollToAnchor,
        setSearchText: setSearchText,
        toolbarHeight: toolbarHeight,
        windowHeight: windowHeight,
        windowWidth: windowWidth,
        windowScrollTop: windowScrollTop
    }

}(jQuery);


//webpack: setting the public path for the exported modules that are dynamically loaded
//see https://webpack.js.org/guides/public-path/
__webpack_public_path__ = function() {
    return __scriptPath.replace("/rb-scripts.js", "/");
}();


function getParameter(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
    var match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}


jQuery(document).ready(function() {
    window.$ = jQuery;
    Rebrush.init();
});
